import React from "react";
import { useLocation } from "react-router-dom";
import { Star } from "lucide-react";
import { useWorkspace } from "../../features/workspace";
import { toastError, toastSuccess } from "../../features/clu/utils/notify";
import { FAVORITES_CONTEXT, findItemForPath, useMobileNavCatalog } from "./mobileNavCatalog";

/**
 * Star in the mobile header: pins or unpins the current page as a favorite.
 * Renders nothing on pages that are not in the pinnable catalog.
 */
const FavoriteToggle: React.FC = () => {
  const location = useLocation();
  const { pinnable } = useMobileNavCatalog();
  const { getPinnedOrder, setPinnedOrder, ready } = useWorkspace(FAVORITES_CONTEXT);

  const item = findItemForPath(pinnable, location.pathname);
  if (!ready || !item) return null;

  const favorites = getPinnedOrder();
  const isFavorite = favorites.includes(item.key);

  const toggle = async () => {
    const next = isFavorite ? favorites.filter((k) => k !== item.key) : [...favorites, item.key];
    try {
      await setPinnedOrder(next);
      toastSuccess(isFavorite ? `${item.label} removed from favorites` : `${item.label} added to favorites`);
    } catch {
      toastError("Could not update favorites");
    }
  };

  return (
    <button
      type="button"
      className="mobile-layout-icon-btn touch-manipulation"
      onClick={toggle}
      aria-pressed={isFavorite}
      aria-label={isFavorite ? `Remove ${item.label} from favorites` : `Add ${item.label} to favorites`}
    >
      <Star
        size={20}
        className={isFavorite ? "text-amber-400" : "text-white/80"}
        fill={isFavorite ? "currentColor" : "none"}
      />
    </button>
  );
};

export default FavoriteToggle;
